import GameContests from './GameContests';
export default GameContests;
